module.exports = __webpack_public_path__ + "prod/1.42.2/img/alibaba-icon.3f83225f.png";